import React, { useState, useEffect } from "react";
import "./Weather.css";

const API_KEY = "d8bbe36eef59d47dc02bd5305aaeb666"; // Reemplázala con tu API Key

function Weather() {
  const [temperature, setTemperature] = useState(null);
  const [weatherIcon, setWeatherIcon] = useState("");
  const [city, setCity] = useState("Desconocido");

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        fetchWeather(latitude, longitude);
      }, (error) => {
        console.error("Error obteniendo la ubicación", error);
      });
    } else {
      console.error("Geolocalización no soportada");
    }
  }, []);

  const fetchWeather = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=metric&appid=${API_KEY}`
      );
      const data = await response.json();
      setTemperature(data.main.temp);
      setWeatherIcon(`https://openweathermap.org/img/wn/${data.weather[0].icon}.png`);
      setCity(data.name);
    } catch (error) {
      console.error("Error obteniendo el clima", error);
    }
  };

  return (
    <div className="weather-container">
      {temperature !== null ? (
        <>
          <span className="weather-city">{city}</span>
          <img src={weatherIcon} alt="Weather icon" className="weather-icon" />
          <span className="weather-temp">{temperature}°C</span>
        </>
      ) : (
        <p>Cargando clima...</p>
      )}
    </div>
  );
}

export default Weather;
